import React from "react";

export default class PopularArticlesSidebar extends React.Component  
{
    constructor(props)    
    {
        super(props);
        this.populars = this.props.populars.length > 0 ? this.props.populars : [];
    }
    
    render()
    {
        return (
            <div class="popular-articles-sidebar mb-5">                
                <div className="card">
                    <h3>Popular Articles</h3>
                    {
                    this.populars.map((popular, index) =>
                    {
                        return( 
                            <div key={index} className="articleContainer">
                                <a href={popular.url} className="eachArticle">
                                    <div className="image">
                                        <img src={popular.image.path} alt={popular.image.alt} loading="lazy"/>
                                    </div>
                                    <div className="text"><span>{popular.title}</span></div>
                                </a>
                            </div>
                        )   
                    })
                    }                 
                </div>
            </div>
        )
    }
};